export default "__VITE_ASSET__PFR3qeCu__"